import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

export const modeVisibleModal = {
  MAIN: "main",
  IMAGE_COMMENT: "image_comment",
} as const;

export type ModeVisibleModal =
  (typeof modeVisibleModal)[keyof typeof modeVisibleModal];

@Injectable({
  providedIn: "root",
})
export class ModalGalleryService {
  public readonly speedVideo$ = new BehaviorSubject<number>(1);
  public readonly speedAudio$ = new BehaviorSubject<number>(1);
  private readonly photosToSend$ = new BehaviorSubject<File[]>([]);
  private readonly isCheckedSetTaskMerch$ = new BehaviorSubject<boolean>(false);
  private readonly modeVisible$ = new BehaviorSubject<ModeVisibleModal>(
    modeVisibleModal.MAIN
  );
  private readonly isOpenEditor$ = new BehaviorSubject<boolean>(false);
  private readonly commentPhotoUrl$ = new BehaviorSubject<string>("");

  public getModeVisible$(): Observable<ModeVisibleModal> {
    return this.modeVisible$;
  }

  public setModeVisible(modeVisible: ModeVisibleModal): void {
    this.modeVisible$.next(modeVisible);
  }

  public onOpenEditor(): void {
    this.isOpenEditor$.next(true);
  }

  public onCloseEditor(): void {
    this.isOpenEditor$.next(false);
  }

  public getStatusEditor(): Observable<boolean> {
    return this.isOpenEditor$;
  }

  public setCommentPhotoUrl(url: string): void {
    this.commentPhotoUrl$.next(url);
    this.modeVisible$.next(modeVisibleModal.IMAGE_COMMENT);
  }

  public getCommentPhotoUrl$(): Observable<string> {
    return this.commentPhotoUrl$;
  }

  public onDoubleVideoSpeed(): void {
    this.speedVideo$.next(2);
  }

  public resetVideoSpeed(): void {
    this.speedVideo$.next(1);
  }

  public onDoubleAudioSpeed(): void {
    this.speedAudio$.next(2);
  }

  public resetAudioSpeed(): void {
    this.speedAudio$.next(1);
  }

  public addPhotoToSend(image: File): void {
    const current = this.photosToSend$.getValue();
    const exists = current.some(
      (f) =>
        f.name === image.name &&
        f.size === image.size &&
        f.lastModified === image.lastModified
    );

    if (!exists) {
      this.photosToSend$.next([...current, image]);
    }
  }

  public setPhotoToSend(image: File[]): void {
    this.photosToSend$.next(image);
  }

  public clearPhotoToSend(): void {
    this.photosToSend$.next([]);
  }

  public getPhotoToSend$(): Observable<File[]> {
    return this.photosToSend$.asObservable();
  }

  public onCheckedSetTaskMerch(status: boolean): void {
    this.isCheckedSetTaskMerch$.next(status);
  }

  public getCheckedSetTaskMerch$(): Observable<boolean> {
    return this.isCheckedSetTaskMerch$.asObservable();
  }
}
